import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface CompleteLeaseDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  contractNumber: string
  onConfirm: () => void
  isPending: boolean
}

export function CompleteLeaseDialog({
  open,
  onOpenChange,
  contractNumber,
  onConfirm,
  isPending,
}: CompleteLeaseDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Complete Lease</AlertDialogTitle>
          <AlertDialogDescription>
            Mark lease{' '}
            <span className="font-mono font-semibold">{contractNumber}</span> as
            completed? This indicates the lease term has ended and the aircraft
            should have already departed.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Completing…' : 'Complete Lease'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
